export default __webpack_public_path__ + "scene1_2_icone2a629.png";